import { useState } from 'react';

import "../../styles/CodeCopyButton.css" 

export const CodeCopyButton = ({ children }) => {
    const [copyOk, setCopyOk] = useState(false);
    const icon = copyOk ? 'bi-clipboard-check' : 'bi-clipboard';

    let language = '';
    try {
        language = children.props.className.replace('language-', '');
    } catch(e) {}

    switch (language) {
        case 'js':
            language = 'javascript';
            break;
    }

    const handleClick = (e) => {
        try {
            const code = e.target.parentElement.parentElement.getElementsByTagName('code')[0].innerText;
            navigator.clipboard.writeText(code);

            setCopyOk(true);
            setTimeout(() => {
                setCopyOk(false);
            }, 1500);
        } catch (e) {
            console.log('could not copy code block:', e)
        }
    }

    return (
        <>
            <div className="code-copy-desc">
                {`${language}`}
            </div>
            <div className="code-copy-btn">
                <i className={`${icon}`} onClick={handleClick} />
            </div>
        </>
    )
}